import { render, staticRenderFns } from "./VTaskReplyList.vue?vue&type=template&id=55d3d0ba&scoped=true"
import script from "./VTaskReplyList.vue?vue&type=script&lang=ts"
export * from "./VTaskReplyList.vue?vue&type=script&lang=ts"
import style0 from "./VTaskReplyList.vue?vue&type=style&index=0&id=55d3d0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d3d0ba",
  null
  
)

export default component.exports